import { Image } from '@valbuild/next';

const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

export interface ImageFeedItem {
  image: Image;
  rotate: string;
}

export const generateImageFeed = (
  images: Image[],
  repeat: number,
  shuffle: boolean
) => {
  let feed: ImageFeedItem[] = [];

  for (const image of images) {
    const rotate = Math.random() > 0.69 ? 'rotate-180' : 'rotate-0';
    feed.push({ image, rotate });
  }

  if (shuffle) {
    feed = shuffleArray(feed);
  }

  const resultFeed: ImageFeedItem[] = [];
  for (let i = 0; i < repeat; i++) {
    resultFeed.push(...feed);
  }

  return resultFeed;
};
